module.exports = __webpack_public_path__ + "img/bookshelf.1c0f57ab.svg";